import { render, staticRenderFns } from "./GlobalConfig.vue?vue&type=template&id=0be2053c"
import script from "./GlobalConfig.js?vue&type=script&lang=js&external"
export * from "./GlobalConfig.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports